import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineBagDollarSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#F5F5F5"
      d="M30.316 2.876c.346.003.686.106.984.299.298.192.545.466.714.795a2.3 2.3 0 0 1-.03 2.15l-3.515 4.934c8.937 4.867 13.405 11.357 13.405 21.091 0 2.076-.401 3.886-1.146 5.444L33.14 30l-7.48 7.48 6.592 6.593c-2.423.707-5.21 1.05-8.252 1.05-10.427 0-17.875-4.023-17.875-12.914 0-9.735 4.47-16.224 13.407-21.124L16.016 6.12a2.3 2.3 0 0 1-.28-1.07c-.006-.378.08-.751.25-1.08s.415-.604.713-.796c.299-.193.638-.296.985-.3z"
    />
    <path
      fill="#B2B2B2"
      d="M30.506 2.134c.426.035.837.176 1.2.41.414.266.748.642.975 1.083a3.05 3.05 0 0 1-.086 2.929l-3.03 4.25c4.181 2.385 7.394 5.175 9.587 8.56 2.325 3.587 3.472 7.79 3.472 12.779 0 2.029-.367 3.829-1.052 5.402-.205.47-.813.557-1.175.195a.81.81 0 0 1-.16-.887c.578-1.363.887-2.928.887-4.71 0-4.746-1.087-8.656-3.23-11.964-2.148-3.314-5.391-6.077-9.785-8.47a.75.75 0 0 1-.252-1.094l3.482-4.885a1.54 1.54 0 0 0 .008-1.418 1.3 1.3 0 0 0-.453-.51 1.1 1.1 0 0 0-.435-.166l-.15-.013H17.69l-.151.013c-.15.023-.298.078-.434.166q-.209.133-.36.354l-.094.156a1.55 1.55 0 0 0 .006 1.416l3.486 4.922a.75.75 0 0 1-.252 1.09c-4.394 2.41-7.637 5.181-9.786 8.5-2.143 3.311-3.23 7.221-3.231 11.967 0 4.2 1.741 7.194 4.694 9.17 2.995 2.002 7.297 2.995 12.431 2.995 2.71 0 5.19-.277 7.365-.834a.78.78 0 0 1 .75.2c.405.406.237 1.094-.319 1.238-2.348.608-4.98.896-7.796.896-5.292 0-9.929-1.018-13.265-3.25-3.376-2.259-5.36-5.724-5.36-10.415 0-4.988 1.147-9.19 3.472-12.782 2.194-3.39 5.407-6.188 9.59-8.588l-3.034-4.285a1 1 0 0 1-.044-.071 3.04 3.04 0 0 1-.374-1.422 3.05 3.05 0 0 1 .333-1.434 2.8 2.8 0 0 1 .975-1.084 2.6 2.6 0 0 1 1.384-.418h12.645z"
    />
    <path
      fill="#fff"
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M24 39c5.8 0 10.5-4.7 10.5-10.5S29.8 18 24 18s-10.5 4.701-10.5 10.5S18.201 39 24 39"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m41.5 46-10-10M26.872 25.5A2.244 2.244 0 0 0 24.75 24h-1.742a2.008 2.008 0 0 0-.429 3.97l2.652.58A2.25 2.25 0 0 1 24.75 33h-1.5a2.25 2.25 0 0 1-2.122-1.5M24 24v-2.25M24 35.25V33"
    />
  </svg>
);
export default SvgStreamlineBagDollarSearch;
